import React, { useState } from "react";
import { Phone } from "lucide-react";
export default function ConsultationSection() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    businessName: "",
    goals: ""
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="consultation" style={{
    backgroundColor: "rgb(248, 250, 252)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(2, 8, 23)",
    fontFamily: '"DM Sans", sans-serif',
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&family=DM+Sans:wght@400;500;600;700&display=swap');
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(24px); }
          100% { opacity: 1; transform: translateY(0px); }
        }
        .consultation-btn:hover {
          opacity: 0.92;
          transform: scale(1.02);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .consultation-btn {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .contact-link:hover {
          color: #2563EB;
          transition: color 0.15s ease;
        }
      `}</style>
      <div className="page-container" style={{
      paddingTop: "112px",
      paddingBottom: "112px"
    }}>
        <div className="flex flex-col md:flex-row gap-16 md:gap-20 items-start">
          
          <div className="w-full md:w-5/12 flex flex-col">
            
            <div className="inline-flex items-center gap-2 self-start" style={{
            backgroundColor: "#EFF6FF",
            border: "1px solid #E2E8F0",
            borderRadius: "9999px",
            padding: "6px 14px"
          }}>
              <span style={{
              color: "#2563EB",
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                  <path d="m21.854 2.147-10.94 10.939"></path>
                </svg>
              </span>
              <span style={{
              fontFamily: '"DM Sans", sans-serif',
              fontSize: "14px",
              fontWeight: 500,
              color: "#1E293B"
            }}>
                Let's Talk
              </span>
            </div>

            
            <h2 style={{
            color: "rgb(30, 41, 59)",
            fontFamily: "Outfit, sans-serif",
            fontSize: "48px",
            fontWeight: "700",
            lineHeight: "56px",
            letterSpacing: "-1.2px",
            border: "0px solid rgb(226, 232, 240)",
            animation: "none 0s ease 0s 1 normal none running",
            marginTop: "16px"
          }}>
              Ready to Grow Your{" "}
              <br />
              <span style={{
              color: "rgb(30, 41, 59)"
            }}>Business </span>
              <span style={{
              color: "#2563EB"
            }}>Online?</span>
            </h2>

            
            <p style={{
            color: "rgb(100, 116, 139)",
            fontFamily: '"DM Sans", sans-serif',
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "29.25px",
            border: "0px solid rgb(226, 232, 240)",
            animation: "none 0s ease 0s 1 normal none running",
            marginTop: "20px"
          }}>
              Whether you need a new website, better Google rankings, or a complete digital marketing strategy, CSN Digital can help. Fill out the form and we'll get back to you within 24 hours.
            </p>

            
            <div style={{
            marginTop: "28px"
          }} className="flex flex-col gap-4">
              
              <div className="flex items-center gap-3">
                <div style={{
                width: "40px",
                height: "40px",
                minWidth: "40px",
                backgroundColor: "#EFF6FF",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#2563EB"
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>
                  </svg>
                </div>
                <div className="flex flex-col">
                  <p style={{
                  color: "rgb(30, 41, 59)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "20px",
                  border: "0px solid rgb(226, 232, 240)",
                  animation: "none 0s ease 0s 1 normal none running",
                  margin: 0
                }}>
                    Call Us Directly
                  </p>
                  <a href="tel:5551234567" className="contact-link" style={{
                  color: "rgb(100, 116, 139)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  border: "0px solid rgb(226, 232, 240)",
                  animation: "none 0s ease 0s 1 normal none running",
                  textDecoration: "none"
                }}>
                    (555) 123-4567
                  </a>
                </div>
              </div>

              
              <div className="flex items-center gap-3">
                <div style={{
                width: "40px",
                height: "40px",
                minWidth: "40px",
                backgroundColor: "#EFF6FF",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#2563EB"
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                  </svg>
                </div>
                <div className="flex flex-col">
                  <p style={{
                  color: "rgb(30, 41, 59)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "20px",
                  border: "0px solid rgb(226, 232, 240)",
                  animation: "none 0s ease 0s 1 normal none running",
                  margin: 0
                }}>
                    Email Us
                  </p>
                  <a href="mailto:hello@csndigital.com" className="contact-link" style={{
                  color: "rgb(100, 116, 139)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  border: "0px solid rgb(226, 232, 240)",
                  animation: "none 0s ease 0s 1 normal none running",
                  textDecoration: "none"
                }}>
                    hello@csndigital.com
                  </a>
                </div>
              </div>
            </div>

            
            <div style={{
            marginTop: "32px",
            backgroundColor: "#FFFFFF",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            padding: "16px 20px"
          }}>
              <div className="flex items-center gap-3">
                
                <div className="flex items-center" style={{
                flexShrink: 0
              }}>
                  {[0, 1, 2, 3].map(i => <div key={i} style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "9999px",
                  backgroundColor: "#2563EB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: i === 0 ? 0 : "-6px",
                  border: "2px solid #FFFFFF",
                  position: "relative",
                  zIndex: 4 - i
                }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M20 6 9 17l-5-5"></path>
                      </svg>
                    </div>)}
                </div>
                
                <p style={{
                fontFamily: '"DM Sans", sans-serif',
                fontSize: "14px",
                margin: 0,
                lineHeight: "20px",
                color: "rgb(100, 116, 139)"
              }}>
                  <span style={{
                  fontWeight: 700,
                  color: "#1E293B"
                }}>
                    180+ local businesses
                  </span>{" "}
                  have trusted us to grow their online presence
                </p>
              </div>
            </div>
          </div>

          
          <div className="w-full md:w-7/12">
            <div style={{
            backgroundColor: "#FFFFFF",
            borderRadius: "16px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.10)",
            padding: "32px"
          }}>
              <form onSubmit={e => e.preventDefault()} className="flex flex-col" style={{
              gap: "20px"
            }}>
                
                <div className="flex flex-col" style={{
                gap: "6px"
              }}>
                  <label style={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#1E293B",
                  lineHeight: "20px"
                }}>
                    Full Name *
                  </label>
                  <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="John Smith" style={{
                  width: "100%",
                  backgroundColor: "transparent",
                  border: "1px solid #E2E8F0",
                  borderRadius: "12px",
                  height: "44px",
                  padding: "10px 16px",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  color: "#1E293B",
                  outline: "none",
                  boxSizing: "border-box"
                }} />
                </div>

                
                <div className="flex flex-col" style={{
                gap: "6px"
              }}>
                  <label style={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#1E293B",
                  lineHeight: "20px"
                }}>
                    Email Address *
                  </label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="john@company.com" style={{
                  width: "100%",
                  backgroundColor: "transparent",
                  border: "1px solid #E2E8F0",
                  borderRadius: "12px",
                  height: "44px",
                  padding: "10px 16px",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  color: "#1E293B",
                  outline: "none",
                  boxSizing: "border-box"
                }} />
                </div>

                
                <div className="flex flex-col" style={{
                gap: "6px"
              }}>
                  <label style={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#1E293B",
                  lineHeight: "20px"
                }}>
                    Phone Number *
                  </label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="(555) 123-4567" style={{
                  width: "100%",
                  backgroundColor: "transparent",
                  border: "1px solid #E2E8F0",
                  borderRadius: "12px",
                  height: "44px",
                  padding: "10px 16px",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  color: "#1E293B",
                  outline: "none",
                  boxSizing: "border-box"
                }} />
                </div>

                
                <div className="flex flex-col" style={{
                gap: "6px"
              }}>
                  <label style={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#1E293B",
                  lineHeight: "20px"
                }}>
                    Business Name
                  </label>
                  <input type="text" name="businessName" value={formData.businessName} onChange={handleChange} placeholder="Your business name" style={{
                  width: "100%",
                  backgroundColor: "transparent",
                  border: "1px solid #E2E8F0",
                  borderRadius: "12px",
                  height: "44px",
                  padding: "10px 16px",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  color: "#1E293B",
                  outline: "none",
                  boxSizing: "border-box"
                }} />
                </div>

                
                <div className="flex flex-col" style={{
                gap: "6px"
              }}>
                  <label style={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#1E293B",
                  lineHeight: "20px"
                }}>
                    Tell Us About Your Goals
                  </label>
                  <textarea name="goals" value={formData.goals} onChange={handleChange} placeholder="What services are you interested in? What are your goals?" rows={4} style={{
                  width: "100%",
                  backgroundColor: "transparent",
                  border: "1px solid #E2E8F0",
                  borderRadius: "12px",
                  minHeight: "100px",
                  padding: "10px 16px",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "14px",
                  color: "#1E293B",
                  outline: "none",
                  resize: "vertical",
                  boxSizing: "border-box"
                }} />
                </div>

                
                <div style={{
                marginTop: "4px"
              }}>
                  <button type="submit" className="consultation-btn w-full flex items-center justify-center gap-2 cursor-pointer" style={{
                  color: "rgb(255, 255, 255)",
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  backgroundImage: "linear-gradient(to right in oklab, rgb(37, 99, 235) 0%, rgb(6, 182, 212) 100%)",
                  borderRadius: "3.35544e+07px",
                  border: "0px solid rgb(226, 232, 240)",
                  padding: "14px 24px",
                  textAlign: "center",
                  animation: "none 0s ease 0s 1 normal none running",
                  width: "100%"
                }}>
                    Get Your Free Consultation
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>

                  
                  <p style={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontSize: "13px",
                  fontWeight: 400,
                  color: "rgb(100, 116, 139)",
                  textAlign: "center",
                  marginTop: "10px",
                  lineHeight: "20px"
                }}>
                    Free, no-obligation consultation. Response within 24 hours.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}